import { Config } from '../Config';

class APIRequestHeader {
    public Key: string;
    public Value: string;

    constructor(key: string, value: string) {
        this.Key = key;
        this.Value = value;
    }
}

class APIRequestQueryParam {
    public Key: string;
    public Value: any;

    constructor(key: string, value: any) {
        this.Key = key;
        this.Value = value;
    }
}

enum APIRequestMethod {
    GET = "GET",
    POST = "POST"
}

enum CacheMode {
    Default = "default",
    ForceCache = "force-cache",
    NoCache = "no-store"
}

class APIRequest {
    public Method: APIRequestMethod;
    public URL: string;    
    public Host: string = Config.API.Base;

    public Headers: APIRequestHeader[] = [];
    public Params: APIRequestQueryParam[] = [];

    public CacheMode: CacheMode = CacheMode.Default;

    public Data?: FormData | object;

    public RUMEnabled: boolean = true;

    constructor(method: APIRequestMethod, url: string, data?: FormData | object) {
        this.Method = method;
        this.URL = url;
        this.Data = data;
    }

    SetCacheMode(cacheMode: CacheMode): APIRequest {
        this.CacheMode = cacheMode;

        return this;
    }

    SetQuery(query: any): APIRequest {
        var keys = Object.keys(query);

        for(var i = 0; i < keys.length; i++) {
            this.Params.push(new APIRequestQueryParam(keys[i], query[keys[i]]));
        }

        return this;
    }

    SetEmbed(embed: boolean): APIRequest {
        this.Params.push(new APIRequestQueryParam('embed', embed));

        return this;
    }

    SetHost(host: string): APIRequest {
        this.Host = host;

        return this;
    }

    SetRUMEnabled(enabled: boolean) {
      this.RUMEnabled = enabled;

      return this;
    }
}

export { APIRequestHeader, APIRequestQueryParam, APIRequestMethod, APIRequest, CacheMode }
